module.exports = __webpack_public_path__ + "img/vertical_3_6_8023.0ee1133a.png";